import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "billing"]

  connect() {
    if (this.element.querySelector('input[type="radio"]:checked')) {
      this.enable()
    }
  }

  enable() {
    this.submitTarget.disabled = false
    this.billingTargets.forEach(el => el.hidden = false)
  }
}
